module.exports = __webpack_public_path__ + "img/circularStrategy2.58489619.png";